import { AxiosResponse } from 'axios';
import {
  CalculateToPayResponse,
  CheckBankHourToUseResponse,
  CreateBankHourData,
  EntryBankHoursData,
  PaidBankHour,
  PayBankHoursData,
  UseBankHoursData,
} from '../@types/bank-hour';
import { BankHour, BankHourHistory } from '../models/bank-hour';
import { api } from '../providers/base-api';
import { PaginatedResponse } from '../utils/types/data/pagination';

export type GetBankHourPaginatedQuery = {
  page: number;
  limit: number;
  username?: string;
  date?: string;
};

export type CalculateBankHoursToPayQuery = {
  users: string;
  interval: string;
  hourBegin?: string;
  hourEnd?: string;
  isPartial?: boolean;
};

export async function createBankHourRequest(
  data: CreateBankHourData,
): Promise<BankHour> {
  const response = await api.post<BankHour>('/bank-hours', data);

  return response.data;
}

export type GetBankHourHistoryPaginatedQuery = {
  page: number;
  limit: number;
  bankHour: number;
};

export type ShowBankHourQuery = {
  id?: number;
  user?: number;
};

export async function getBankHoursRequest(
  params: GetBankHourPaginatedQuery,
): Promise<AxiosResponse<PaginatedResponse<BankHour>>> {
  const response = await api.get<PaginatedResponse<BankHour>>('/bank-hours', {
    params,
  });

  return response;
}

export async function removeBankHourRequest(
  id: number,
): Promise<AxiosResponse<void>> {
  const response = await api.delete(`/bank-hours/${id}`);

  return response;
}

export async function payBankHoursRequest(
  data: PayBankHoursData,
): Promise<AxiosResponse<PaidBankHour[]>> {
  const response = await api.post<PaidBankHour[]>('/bank-hours/pay', data);

  return response;
}

export async function toUseBankHoursRequest(
  data: UseBankHoursData,
): Promise<AxiosResponse<void>> {
  const response = await api.post<void>('/bank-hours/use', data);

  return response;
}

export async function calculateBankHoursRequest(
  params: CalculateBankHoursToPayQuery,
): Promise<AxiosResponse<CalculateToPayResponse[]>> {
  const response = await api.get<CalculateToPayResponse[]>(
    '/work-histories/calculate-to-pay',
    {
      params,
    },
  );

  return response;
}

export async function getBankHoursHistoryRequest(
  params: GetBankHourHistoryPaginatedQuery,
): Promise<AxiosResponse<PaginatedResponse<BankHourHistory>>> {
  const response = await api.get<PaginatedResponse<BankHourHistory>>(
    '/bank-hour-histories',
    {
      params,
    },
  );

  return response;
}

export async function showBankHour(
  params: ShowBankHourQuery,
): Promise<AxiosResponse<BankHour>> {
  const response = await api.get<BankHour>('/bank-hours/show', { params });

  return response;
}

export async function CheckBankHourToUse(
  params: CalculateBankHoursToPayQuery,
): Promise<AxiosResponse<CheckBankHourToUseResponse[]>> {
  const response = await api.get<CheckBankHourToUseResponse[]>(
    '/bank-hours/check-to-use',
    { params },
  );

  return response;
}

export async function entryHours(
  bankId: number,
  data: EntryBankHoursData,
): Promise<AxiosResponse<void>> {
  const response = await api.post<void>(`/bank-hours/entry/${bankId}`, data);
  return response;
}

export type MyBankHourResponse = {
  amount: number;
  dailyWorkAmount: number;
  total: number;
  composedAmount: string;
};

export async function getMyBankHour(): Promise<MyBankHourResponse> {
  const response = await api.get<MyBankHourResponse>('/bank-hours/me');

  return response.data;
}
